module.exports = __webpack_public_path__ + "static/media/landing-page-cover.cd27254c.png";